import { render, staticRenderFns } from "./TaskNewForm.vue?vue&type=template&id=8d071be0"
import script from "./TaskNewForm.vue?vue&type=script&lang=js"
export * from "./TaskNewForm.vue?vue&type=script&lang=js"
import style0 from "./TaskNewForm.vue?vue&type=style&index=0&id=8d071be0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports